
import React from 'react';
import { connect } from 'react-redux';
import * as ConfigTypes from 'config/ConfigTypes';
import { withRouter } from 'helpers/ModuleHelper';
import { injectIntl } from 'react-intl';
import { Flow } from 'flow-react';
import { observer } from 'mobx-react';
import { getMetaConfig } from "helpers/ConfigHelper";
import ListItem from "components/Cart/ListItem/ListItem";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { showFeCartMsg } from "helpers/CartHelper";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import * as actions from 'store/actions';
import './WishList.scss';

const WishList = observer(
    class WishList extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                wishlist: []
            }
        }

        fm = ({ id }) => this.props.intl.formatMessage({ id });

        getHeaderClasses = (configName) => {
            if (configName === ConfigTypes.ITEM) return "wishlist-header-items";
            if (configName === ConfigTypes.WORK) return "wishlist-header-works";
            return "wishlist-header";
        }

        onListWorkClick = (work) => {
            const { currentWork, wpView } = this.props.mediaObjects;
            this.props.updateMediaObjects({
                viewMode: ConfigTypes.WORK_DETAIL, wpView: ConfigTypes.WORK_LIST,
                toTop: true, lastView: ConfigTypes.CART_MAINPAGE
            });
            if (work && work.id && (!currentWork || (currentWork && work.id !== currentWork.id))) {
                this.props.getWork({ workId: work.id });
            }
            this.props.router.navigate(`${ConfigTypes.WORK_PATH}/${work.id}`);
        };

        onListItemClick = (item) => {
            const { wpView } = this.props.mediaObjects;
            this.props.updateMediaObjects({
                currentClip: item,
                wpView: ConfigTypes.ITEM_DETAIL,
                viewMode: ConfigTypes.ITEM_DETAIL,
                toTop: true,
                lastView: wpView
            });
            this.props.onCloseModal();
            this.props.router.navigate(`${ConfigTypes.ITEM_PATH}/${item.id}`);
        }

        onDateAction = async ({ item, dates }) => {
            const { itemsWishList, itemsDateObj } = this.props.cartObjects;
            let newDates = dates.map(date => {
                let newDate = date.setTime(date.getTime() + ConfigTypes.ADD_TWO_HOURS);
                newDate = new Date(newDate).toISOString().split('T')[0];
                return newDate;
            });
            const newItems = itemsWishList.map(el => {
                if (el.id === item.id) el.showdates = newDates;
                return el;
            });

            console.log("LOGS: onDateAction WishList item newDates", item, newDates);
            const res = await window.flow.sdkFeReAddToCart(item.id, newDates);
            console.log("LOGS: addToFeCart res", res);
            if (res && res.success) {
                let nItemsWishList = itemsWishList.filter(entry => entry.id != item.id);
                this.props.updateCartObjects({
                    itemsCartList: newItems, itemsWishList: nItemsWishList,
                    itemsDateObj: { ...itemsDateObj, [item.id]: newDates }
                });
            }
            if (res.msg) showFeCartMsg({ msg: res.msg, fm: this.fm, props: this.props });
        }

        onOtherActions = ({ item, action }) => {
            const { itemsWishList, itemsCartList } = this.props.cartObjects;
            let newItemsCart = [...itemsCartList];
            let newItemsWishList = itemsWishList.filter(li => li.id !== item.id);
            if (action && action === ConfigTypes.ADD_TO_CART) {
                let cartIdx = itemsCartList.findIndex(el => el.id === item.id);
                if (cartIdx > -1) {
                    newItemsCart = itemsCartList.map(el => {
                        if (el.id === item.id) {
                            let cartAmount = 1;
                            if (el.cartAmount) cartAmount = el.cartAmount + 1;
                            return { ...el, cartAmount };
                        }
                        return el;
                    });
                } else {
                    newItemsCart.push({ ...item, cartAmount: 1 });
                }
            }
            this.props.updateCartObjects({ itemsWishList: newItemsWishList, itemsCartList: newItemsCart });
            if(item.watchlist_id && item.orig_id){
                this.props.removeFromWatchlist({listid: item.watchlist_id,listelid: item.orig_id, fm: this.fm});
            }
        }

        isEmpty = () => {
            const { worksWishList, itemsWishList } = this.props.cartObjects;
            if (worksWishList.length === 0 && itemsWishList.length === 0) return true;
            return false;
        }

        getShowFields = () => {
            let configName = ConfigTypes.ITEM;
            let showFields = getMetaConfig({ viewMode: ConfigTypes.WISHLIST, props: this.props, configName });
            let addFields = getMetaConfig({
                viewMode: ConfigTypes.WISHLIST_WORKTOITEM,
                props: this.props, configName: ConfigTypes.WORK
            });

            addFields = addFields.map(el => ({ ...el, field: `${ConfigTypes.ONLY_CART}${el.field}` }));
            showFields.splice(2, 0, ...addFields);
            showFields = showFields.filter(field => !field[`${ConfigTypes.WISHLIST_WORKTOITEM}hidden`]);
            return showFields;
        }


        showItemsWishList = () => {
            const { itemsWishList } = this.props.cartObjects;
            if (itemsWishList && itemsWishList.length > 0) {
                let showFields = this.getShowFields();
                return (
                    <div>
                        <h3 className="wishlist-heading">
                            {this.props.intl.formatMessage({ id: "wishlist.items" })}
                        </h3>
                        <div className={this.getHeaderClasses(ConfigTypes.ITEM)}>
                            {showFields.map(item => (<div>{this.props.intl.formatMessage({ id: item.intl })}</div>))}
                        </div>
                        <ul className="wishlist-body">
                            {itemsWishList.map((item, i) => (
                                <ListItem key={`wishlistCard_${i}`} actions={ConfigTypes.WISHLIST_ITEMS_ACTIONS}
                                    item={item} curMode={ConfigTypes.WISHLIST} configName={ConfigTypes.ITEM}
                                    onOtherActions={this.onOtherActions} showFields={showFields}
                                    formatMessage={this.props.intl.formatMessage} cartObjects={this.props.cartObjects}
                                    onDateAction={this.onDateAction} onListItemClick={this.onListItemClick} />)
                            )}
                        </ul>
                    </div>)
            }
        }

        onDeleteWorkItem = ({ item, el, userInputs }) => {
            const { worksWishList } = this.props.cartObjects;
            console.log("LOGS: onDeleteWorkItem item el", item, el);
            if (worksWishList && worksWishList.length) {
                let newWorksWishList = worksWishList.map(entry => {
                    if (entry.id == item.id) {
                        let idx = entry.showdates.indexOf(el);
                        if (idx > -1) {
                            entry.showdates = entry.showdates.filter(d => d == el);
                            entry.shows = entry.shows.slice(idx, 1);
                        }
                    }
                    return this.setShowsCount({ entry, item, userInputs });
                });
                console.log("LOGS: onDeleteItem newWorksWishList", newWorksWishList);
                this.props.updateCartObjects({ worksWishList: newWorksWishList });
                if(item.watchlist_id && item.orig_id){
                    this.props.removeFromWatchlist({listid: item.watchlist_id,listelid: item.orig_id, fm: this.fm});
                }  
            }
        }

        onWorkOtherActions = ({ item, action }) => {
            const { worksWishList } = this.props.cartObjects;
            let newWorksWishList = [...worksWishList];
            if (action && action === ConfigTypes.DELETE) {
                newWorksWishList = worksWishList.filter(li => li.id !== item.id);
            }
            this.props.updateCartObjects({ worksWishList: newWorksWishList });
            console.log("LOGS: onWorkOtherActions item", item);
            if(item.watchlist_id && item.orig_id){
                this.props.removeFromWatchlist({listid: item.watchlist_id,listelid: item.orig_id, fm: this.fm});
            }  
        }

        showWorksWishList = () => {
            const { worksWishList } = this.props.cartObjects;
            if (worksWishList && worksWishList.length > 0) {
                let configName = ConfigTypes.WORK;
                const showFields = getMetaConfig({ viewMode: ConfigTypes.WISHLIST, props: this.props, configName });
                return (
                    <div>
                        <h3 className="wishlist-heading">
                            {this.props.intl.formatMessage({ id: "wishlist.works" })}
                        </h3>
                        <div className={this.getHeaderClasses(configName)}>
                            {showFields.map(item => (<div>{this.props.intl.formatMessage({ id: item.intl })}</div>))}
                        </div>
                        <ul className="wishlist-body">
                            {worksWishList.map((item, i) => (
                                <ListItem key={`wishlistCard_${i}`} curMode={ConfigTypes.WISHLIST}
                                    item={item} configName={configName} showFields={showFields}
                                    cartObjects={this.props.cartObjects} actions={ConfigTypes.WORKLIST_ITEMS_ACTIONS}
                                    onOtherActions={this.onWorkOtherActions} onListItemClick={this.onListWorkClick} />
                            ))}
                        </ul>
                    </div>)
            }
        }

        showFormTitle = () => {
            return (
                <h1 className="wishlist-title">
                    <span><FontAwesomeIcon icon={faHeart} /></span>
                    {this.props.intl.formatMessage({ id: "wishlist.heading" })}
                </h1>
            )
        }

        showFormInfo = () => {
            return (
                <div className="wishlist wishlist-infoxbox">
                    <div>
                        {this.showFormTitle()}
                        <p className="wishlist-info">
                            {this.props.intl.formatMessage({ id: "wishlist.emptyinfo" })}
                        </p>
                    </div>
                </div>
            )
        }

        componentDidUpdate(prev) { }

        componentDidMount() { }

        render() {
            //if (this.isEmpty()) return this.showFormInfo();
            return (
                <div className="wishlist">
                    {(!this.state.loading) && (
                        <div>
                            {this.showFormTitle()}
                            {this.showWorksWishList()}
                            {this.showItemsWishList()}
                        </div>
                    )}
                </div>
            )
        }
    }
)

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects,
    configObjects: state.config.configObjects,
    cartObjects: state.cart.cartObjects,
});

const mapDispatchToProps = (dispatch) => ({
    updateCartObjects: (obj) => dispatch(actions.updateCartObjects(obj)),
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj)),
    getWork: (data) => dispatch(actions.getWork(data)),
    removeFromWatchlist: (obj) => dispatch(actions.removeFromWatchlist(obj))
})

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(injectIntl(withRouter(WishList))));